import React, { Fragment } from 'react';

interface Props {
  path: string;
}

const Redirect = ({ path }: Props) => {
  window?.location.assign(path);
  return <Fragment />;
};

export default Redirect;
